export default "__VITE_ASSET__dc4c014f__"